import React, { Component } from "react";
import "./App.css";
import { Container, Row, Col } from "reactstrap";
import Carousel from "./responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Tooltip from "@material-ui/core/Tooltip";

//npm start; npm run build; firebase deploy

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <p className="App-title">Natalie Whitten</p>
          <div
            className="Links buttons"
            style={{ width: "100%", textAlign: "right" }}
          >
            <Tooltip title="Github">
              <a href="https://github.com/Nschennum">
                <i
                  className="fa fa-github fa-lg links"
                  style={{ color: "white", marginRight: "1rem" }}
                />
              </a>
            </Tooltip>
            <Tooltip title="Email">
              <a href="mailto:natalie.s.whitten@gmail.com">
                {" "}
                <i
                  className="fa fa-envelope fa-lg links"
                  style={{ color: "white", marginRight: "1.1rem" }}
                />
              </a>
            </Tooltip>
            <Tooltip title="LinkedIn">
              <a href="https://www.linkedin.com/in/natalie-s-whitten/">
                <i
                  className="fa fa-linkedin fa-lg links"
                  style={{ color: "white", marginRight: "1rem" }}
                />
              </a>
            </Tooltip>
          </div>
        </header>
    
          <Container className="About-Section">
            <div className="aboutSectionL">

              <div className="header-top-inner" >
              <img
                  className="selfie circle"
                  src={require("./images/bnw.jpg")}
                  alt="me"
                />
                <p
                  className="Title BorderBottom mb-0"
                  style={{ borderBottom: "1px solid black"}}
                >
                  Web Developer
                </p>

                <p className="Title pt-0">Data Services</p>

                
                <p className="pt-2">
                  I work with Web Applications and Data. If you have a problem you need solved or 
                  an idea that needs implementation, I can help. Always open to discussing new ideas with
                  other developers and people aiming to do great things!
   

                  
                </p>
              </div>

            </div>
            <div className="aboutSectionR pt-3">
              <p className="aboutSectionR-inner">
              <br />
              <p style={{ borderBottom: "1px solid black"}}>Dev/Data Skills</p>
              <p>UI/UX</p>
              <p>Angular/React</p>
              <p>ASP.NET</p>
              <p>Python</p>
              <p>SQL/SSMS/ORACLE</p>
              <p>Firebase/Azure/AWS</p>
              <p>Forms</p>
              <p>PowerBi</p>
              <p>OSI Pi Soft Tools</p>
              <p>Esri/ArcGIS</p>
              <p>General Web Services</p>

              </p>            
                </div>
          </Container>

        <Container
          style={{ margin: "0", width: "100vw" }}
          className="Skills-Section"
        >
          <Row className="Skills-Row">
            <Col className="items" sm="3.5">
              <p>Thank you Natalie! 
Everything looks great! Thank you for your assistance in planning here and getting this gone so quickly!</p>
              <p>~Pastor Todd</p>
              <a href="https://www.richlandredeemer.org/">richlandredeemer.org</a>

  
            </Col>
            <Col className="items" sm="3.5">
              <p>The website looks good and the form is exactly what I was looking for! I'm impressed with the functionality and 
look and feel of the site. Its beautiful. </p>
              <p>~Chuck Grijalva RRT</p>
              <a href="https://redoxhealthycells.net/">redoxhealthycells.net</a>
            </Col>
            <Col className="items" sm="3.5">
              <p>It has been so long since our website had work done on it. Thank you for finally getting this looking professional. 
That was much quicker than we expected. Thank you!</p>
              <p>~BCRP Chairman</p>
              <a href="https://www.bcrpwa.com/">bcrpwa.com</a>
  
            </Col>
          </Row>
        </Container>
        <div className="projects-outer">
          <div className="projects">
            <Carousel />
          </div>
        </div>
        <Container class="form p-3"> 
        <div class="form-inner"><iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdgmjNHRdZuQB4Q6R4MWiGA1rkPWTAzAkzzZut41ExJW6UGNg/viewform?embedded=true" width="640" height="1576" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
 </div>
              </Container>
       
        {/* <div className="Project-Links">
          <a href="https://coders-connect-2019.herokuapp.com/">Checkout Coders Connect</a><p>(UN: tester@email.com; PW: test123)</p>-
          <a href="https://kc-real-estate.herokuapp.com/">Checkout KC Real Estate</a>
          </div> */}
        <div
          style={{ margin: "0", maxwidth: "80px" }}
          className="Skills-Section2"
        >
          <div className="icons">
            <Tooltip title="HTML" placement="top">
              <a href="https://developer.mozilla.org/en-US/docs/Web/HTML">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/html.svg")}
                  alt="html"
                />
              </a>
            </Tooltip>
            <Tooltip title="PowerBI" placement="top">
              <a href="https://powerbi.microsoft.com/en-us/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/powerbi.png")}
                  alt="css"
                />
              </a>
            </Tooltip>
            <Tooltip title="Python" placement="top">
              <a href="https://www.python.org/">
                <img
                  className="icon"
                  height="80"
                  src={require("./icons/python.svg")}
                  alt="python"
                />
              </a>
            </Tooltip>
            <Tooltip title="ReactJS" placement="top">
              <a href="https://reactjs.org/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/react.svg")}
                  alt="react"
                />
              </a>
            </Tooltip>
            <Tooltip title="NodeJS" placement="top">
              <a href="https://nodejs.org/en/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/node.svg")}
                  alt="node"
                />
              </a>
            </Tooltip>
            <Tooltip title="Firebase" placement="top">
              <a href="https://firebase.google.com/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/firebase.svg")}
                  alt="firebase"
                />
              </a>
            </Tooltip>
            <Tooltip title="SQL" placement="top">
              <a href="https://www.w3schools.com/sql/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/SQL.svg")}
                  alt="SQL"
                />
              </a>
            </Tooltip>
            <Tooltip title="ASP.NET" placement="top">
              <a href="https://dotnet.microsoft.com/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/net.png")}
                  alt="NET"
                />
              </a>
            </Tooltip>
            <Tooltip title="Heroku" placement="top">
              <a href="https://www.heroku.com/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/heroku.png")}
                  alt="heroku"
                />
              </a>
            </Tooltip>
            <Tooltip title="MongoDB" placement="top">
              <a href="https://www.mongodb.com/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/mongodb.png")}
                  alt="MongoDB"
                />
              </a>
            </Tooltip>
            <Tooltip title="AngularJS" placement="top">
              <a href="https://angular.io/">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/angular.svg")}
                  alt="angular"
                />
              </a>
            </Tooltip>
            <Tooltip title="ArcGIS" placement="top">
              <a href="https://www.esri.com/en-us/home">
                <img
                  className="icon"
                  height="65"
                  src={require("./icons/esri.png")}
                  alt="esri"
                />
              </a>
            </Tooltip>
          </div>
        </div>

        <div className="Bottom-Bar">
          <a href="mailto:natalie.s.whitten@gmail.com">
            {" "}
            <i className="fa fa-envelope bottom" style={{ color: "white" }} />
          </a>{" "}
          <p className="bottom-bar-text"> natalie.s.whitten@gmail.com</p>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js